import React from 'react';
import { Municipalities } from '../components';

export default () => {
    return (
        <Municipalities.Home />
    )
}